// Mapping of frontend DMS names to backend enum numeric values
// Keep this in sync with backend enum OPE.Identity.ManagementSystem.Common.DTOs.Enums.DmsTypes
// All=-2, Unknown=-1, Ideal=0, Infinity=1, Enterprise=2, Softbiz=3, SoftPower=4, IdealDOS=5,
// PaulsonInventrack=6, PaulsonMarineSoft=7, OldIdeal=8, Aspen=9, IDS=11, DIS=12

const RAW_MAP: Record<string, number> = {
  All: -2,
  Unknown: -1,
  Ideal: 0,
  Infinity: 1,
  Enterprise: 2,
  Softbiz: 3,
  SoftPower: 4,
  IdealDOS: 5,
  PaulsonInventrack: 6,
  PaulsonMarineSoft: 7,
  OldIdeal: 8,
  Aspen: 9,
  IDS: 11,
  DIS: 12,
};

// Build a case-insensitive map
const MAP_CI: Record<string, number> = Object.keys(RAW_MAP).reduce((acc, key) => {
  acc[key.toLowerCase()] = RAW_MAP[key];
  return acc;
}, {} as Record<string, number>);

export function mapDmsFilterToEnumValue(value: string | number | undefined | null): number {
  if (typeof value === 'number' && !Number.isNaN(value)) return value;
  if (value == null || value === '') return RAW_MAP.All; // default to All
  const normalized = String(value).trim().toLowerCase();
  if (normalized in MAP_CI) return MAP_CI[normalized];
  // Some APIs may return slightly different display names; add fallbacks here if needed
  // Default to All if unmapped
  switch (normalized) {
    case "paulson inventrack":
      return RAW_MAP.PaulsonInventrack;
    case "paulson marinesoft":
      return RAW_MAP.PaulsonMarineSoft;
    case "old ideal":
      return RAW_MAP.OldIdeal;
    case "soft power":
      return RAW_MAP.SoftPower;
    case "ideal dos":
      return RAW_MAP.IdealDOS;
    default:
      return RAW_MAP.All;
    }
}

export const DMS_ENUM_MAP = RAW_MAP;
